import script from "./PolicyEditPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyEditPage.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyEditPage.vue?vue&type=style&index=0&id=88b125a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88b125a8"]])

export default __exports__